export const CAMERA_SCHEDULE_STRINGS = {
  tooltip: {
    permanentRules:
      'Permanent rules should be used for continuous, permanent acquisition and should not be modified frequently.',
    temporaryRules:
      'Temporary, additional rules will allow a acquisition change for a defined period of time and then return to the permanent rule.',
    simultaneousRules:
      'Temporary and permanent rules apply simultaneously. Temporary rules do not suspend permanent rules.',
    questions: 'If you have any questions, please',
    consultManual: 'consult our manual',
    or: 'or',
    contactSpecialist: 'contact one of our specialists',
    consultManualUrl: 'https://www.vectronic-aerospace.com/editing-schedules/',
    contactUrl: 'https://www.vectronic-aerospace.com/support/',
    exportScheduleJson: 'Export Schedule JSON',
  },
  buttons: {
    discardChanges: 'Discard changes',
    removeExistingCameraSchedule: 'Remove existing camera schedule',
    removeCameraSchedule: 'Remove camera schedule',
    resetScheduleToFactory: 'Reset schedule to factory',
    addRule: 'Add Rule',
    addCameraSchedule: 'Add Camera Schedule',
    loadSchedule: 'Load Schedule',
    loadFromTemplate: 'Load from Template',
    loadGpsXFile: 'Load GPS+X file',
    saveAs: 'Save as',
    saveAsTemplate: 'Save as Template',
    importJson: 'Import JSON',
    exportJson: 'Export JSON',
    saveTemplate: 'Save Template',
    submit: 'Submit',
  },
  warnings: {
    overwriteWarning:
      'Overwrite Warning: This will replace your current CAMERA Schedule. Changes are not additive.',
    removingScheduleWarning:
      'Warning: Removing this schedule will disable all activity of this schedule type on the collar.',
    removingScheduleDescription: 'This command removes the schedule on the device.',
  },
  errors: {
    scheduleNotAvailable: 'This schedule is only available for',
    canNotBeCombined: (collars: string) => `${collars}: Can not be combined in one command`,
    moreThanOneCameraType: 'Camera schedules can be configured only for one camera type',
  },
  form: {
    templateNameLabel: 'Template Name',
  },
};
